import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { pillarArticles } from "@/mocks/pillarArticles";

export default function PillarArticlesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-bold text-accent-900">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
            </span>
            {t("pillars.eyebrow")}
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">{t("pillars.title")}</h2>
          <p className="mt-3 text-base text-foreground-600">{t("pillars.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/guides/${article.slug}`}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform hover:-translate-y-1"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`text-xl ${article.icon}`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{article.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {article.quickAnswer.length > 110
                  ? `${article.quickAnswer.slice(0, 110)}…`
                  : article.quickAnswer}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary-700">
                {t("pillars.readMore")}
                <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}